module.exports = __webpack_public_path__ + "img/Patricia.49041538.png";